module.exports = __webpack_public_path__ + "img/Weapon_280.1396971c.png";